var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-item-template',[_c('data-property-profile-list',{attrs:{"data-property-profiles":_vm.dataPropertyProfiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }